import CustomButton from 'components/Buttons/CustomButton'
import ProfilePic from 'components/PMBProfilePic'
import BreadCrumbs from 'components/breadcrumbs'
import { Can } from 'context/Acl'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  ArrowRight,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  DollarSign,
  Edit,
  Eye,
  Filter,
  AlertCircle,
  FileText,
} from 'react-feather'
import { PMBDateRangePicker } from 'components/PMBNewDatePicker'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Alert,
  Badge,
  Card,
  CardBody,
  Col,
  Collapse,
  Progress,
  Row,
  Spinner,
  Modal,
  ModalBody,
  Input,
  Label,
} from 'reactstrap'
import { formatDatePMB, formatDatePMBV2 } from 'utils/formatDate'
import {
  URL_DETAIL_PIUTANG,
  URL_DETAIL_UTANG,
  URL_FORM_UTANG_PIUTANG,
  URL_UTANG_APPROVAL,
} from 'utils/pathUrl'
import { BUSINESS_AR_AP, BUSINESS_AR_AP_COMPANY, MANAGE, READ } from 'utils/subjectActions'
import {
  toggleBannerReceivable,
  toggleModalAdjustReceivable,
  toggleSidebarReceivable,
  setFetchOptionReceivable as setFetchOptionReceivableCompany,
  setFetchOptionReceivablePersonal,
} from '../receivable-notes/receivableNotesSlice'
import SidebarPayableNotes from './SidebarPayableNotes'
import { getPendingPayable, getPendingPayablePersonal, getUsersFilterArap, getUsersFilterArapPersonal } from './payableAction'
import {
  useGetPayablePersonalQuery,
  useGetPayableQuery,
  useMergeReceiveableMutation,
  useMergeReceiveablePersonalMutation,
  useGetCategoriesQuery,
  useGetCategoriesPersonalQuery,
} from './payableNotesApiSlice'
import {
  setFetchOption as setFetchOptionCompany,
  setFetchOptionPersonal,
  toggleBanner,
  toggleModalAdjust,
  toggleSidebar,
} from './payableNotesSlice'
import { TableComponent } from 'components/TableComponent'
import PMBPagination from 'components/PMBPagination'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import LihatDetail from 'components/Icons/LihatDetail'
import ModalAdjustPayable from './ModalAdjustPayable'
import { useDebounce } from 'helpers'
import PMBSelect from 'components/PMBSelect'
import DropdownAddressBook from '../address-book/DropdownAddressBook'
import { setSearchAddressBook } from '../address-book/addressBookSlice'
import moment from 'moment-timezone'
import { P } from 'components'
import SvgIcon from 'components/Icon/SvgIcon'
import PMBProjectSelections from 'components/PMBProjectSelections'
import { useSnackbar } from 'notistack'
import { useAbilityAccess } from 'hooks/useAbilityAccess'

const PayableNotes = ({
  dataReceivable,
  isOpenSidebarReceivable,
  isOpenBannerReceivable,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const intl = useIntl()
  const { enqueueSnackbar } = useSnackbar()
  const f = dataReceivable ? 'receivable' : 'payable'

  const [selectedRow, setSelectedRow] = useState(null)
  const {
    tag: tagCompany,
    tagPersonal,
    isOpenBanner,
    isOpenSidebar,
    bannerMsg,
    pendingPayable,
    loading,
    isOpenModalAdjust,
    usersFilterArap,
    type,
  } = useSelector((s) => s.payableNotes)
  const {
    isOpenModalAdjust: isOpenModalAdjustReceivable,
    tag: tagReceiveableCompany,
    tagPersonal: tagReceiveablePersonal,
  } = useSelector((state) => state.receivableNotes)

  const { profile, ownerData } = useSelector((s) => s.dashboard)
  const userId = type === 'personal' ? profile?.userId : ownerData?.userId

  const tag = type === 'personal' ? tagPersonal : tagCompany
  const tagReceiveable = type === 'personal' ? tagReceiveablePersonal : tagReceiveableCompany

  const setFetchOption = type === 'personal' ? setFetchOptionPersonal : setFetchOptionCompany
  const setFetchOptionReceivable = type === 'personal' ? setFetchOptionReceivablePersonal : setFetchOptionReceivableCompany

  const hasPersonalAbilityREAD = useAbilityAccess({ action: READ, subject: BUSINESS_AR_AP })
  const hasCompanyAbilityREAD = useAbilityAccess({ action: READ, subject: BUSINESS_AR_AP_COMPANY })

  const hasPersonalAbilityMANAGE = useAbilityAccess({ action: MANAGE, subject: BUSINESS_AR_AP })
  const hasCompanyAbilityMANAGE = useAbilityAccess({ action: MANAGE, subject: BUSINESS_AR_AP_COMPANY })

  const [selectedRows, setSelectedRows] = useState([])
  const [toggledClearRows, setToggleClearRows] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const [selectedContact, setSelectedContact] = useState(null)
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [isOpenMergeModal, setIsOpenMergeModal] = useState(false)
  const [mergeInvoiceNum, setMergeInvoiceNum] = useState('')
  const [mergeNotes, setMergeNotes] = useState('')
  const [mergeProject, setMergeProject] = useState(null)

  const addressBookRef = useRef(null)

  const { data: dataCompany, isLoading: isLoadingCompany, refetch: refetchCompany, status: statusCompany } = useGetPayableQuery({
    type: dataReceivable ? 'receivable' : 'payable',
    ...(dataReceivable ? { ...tagReceiveable, typeFetch: type } : { ...tag, typeFetch: type }),
  }, { skip: type !== 'company' })

  const { data: dataPersonal, isLoading: isLoadingPersonal, refetch: refetchPersonal, status: statusPersonal } = useGetPayablePersonalQuery({
    type: dataReceivable ? 'receivable' : 'payable',
    ...(dataReceivable ? { ...tagReceiveable, typeFetch: type } : { ...tag, typeFetch: type }),
  }, { skip: type !== 'personal' })

  const [mergeReceiveableCompany, { isLoading: isMergingCompany }] =
    useMergeReceiveableMutation()
  const [mergeReceiveablePersonal, { isLoading: isMergingPersonal }] =
    useMergeReceiveablePersonalMutation()

  const { data: dataCategoryCompany } = useGetCategoriesQuery(
    {
      type: dataReceivable ? 'receivable' : 'payable',
      active: 1,
      userId: userId,
    },
    { skip: !userId || type === 'personal' },
  )

  const { data: dataCategoryPersonal } = useGetCategoriesPersonalQuery(
    {
      type: dataReceivable ? 'receivable' : 'payable',
      active: 1,
      userId: userId,
    },
    { skip: !userId || type === 'company' },
  )

  const dataCategory = type === 'personal' ? dataCategoryPersonal : dataCategoryCompany

  const categoryOptions = Array.isArray(dataCategory) ? dataCategory.map(item => ({
    label: item.label,
    value: item.id
  })) : []

  const mergeReceiveable = type === 'personal' ? mergeReceiveablePersonal : mergeReceiveableCompany
  const isMerging = type === 'personal' ? isMergingPersonal : isMergingCompany

  const data = type === 'personal' ? dataPersonal : dataCompany
  const isLoading = type === 'personal' ? isLoadingPersonal : isLoadingCompany
  const refetch = type === 'personal' ? refetchPersonal : refetchCompany
  const status = type === 'personal' ? statusPersonal : statusCompany

  useEffect(() => {
    setSelectedRows([])
    setToggleClearRows((v) => !v)
  }, [data?.items?.length])

  useEffect(() => {
    if (!dataReceivable) {
      if (type === 'personal') {
        dispatch(getPendingPayablePersonal())
      } else {
        dispatch(getPendingPayable())
      }
    }
  }, [dataReceivable, type])

  const activeFilterCount = useMemo(() => {
    let count = 0
    if (tag?.status) count++
    if (tag?.search) count++
    if (tag?.from || tag?.to) count++
    if (tag?.counterparty) count++
    if (tag?.search) count++
    if (tag?.projectId) count++
    if (tag?.categoryId) count++
    return count
  }, [tag])

  const activeFilterCountReceivable = useMemo(() => {
    let count = 0
    if (tagReceiveable?.status) count++
    if (tagReceiveable?.search) count++
    if (tagReceiveable?.from || tagReceiveable?.to) count++
    if (tagReceiveable?.counterparty) count++
    if (tagReceiveable?.search) count++
    if (tagReceiveable?.projectId) count++
    if (tagReceiveable?.categoryId) count++
    return count
  }, [tagReceiveable])

  const summary = useMemo(() => {
    const items = data?.items || []
    const totalItems = items.length
    const totalOutstanding = items.reduce((acc, it) => {
      const remaining = (it?.amount ?? 0) - (it?.amountPaid ?? 0)
      return acc + Math.max(0, remaining)
    }, 0)
    return { totalItems, totalOutstanding }
  }, [data])

  const statusOptions = [
    {
      value: undefined,
      label: 'Semua',
    },
    {
      value: 'open',
      label: 'Open',
    },
    {
      value: 'paid',
      label: 'Paid',
    },
    {
      value: 'partial',
      label: 'Partial',
    },
  ]

  // status helper
  const getStatus = (it) => {
    const amount = Number(it?.amount ?? 0)
    const paid = Number(it?.amountPaid ?? 0)

    const isManual = !it?.userId || !it?.payerUserId || !it?.escrowpaymentId

    if (isManual) return 'CATAT_MANUAL'

    if (amount > 0 && paid >= amount) return 'LUNAS'

    return 'TRANSAKSI'
  }

  const debouncedSearch = useDebounce((value) => {
    if (dataReceivable) {
      dispatch(
        setFetchOptionReceivable({
          page: 0,
          search: value,
        }),
      )
    } else {
      dispatch(
        setFetchOption({
          page: 0,
          search: value,
        }),
      )
    }
  }, 600)

  const onHandleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && tag?.s.length === 0) {
      e.preventDefault()
    }
  }

  const handleSort = (column, direction) => {
    if (dataReceivable) {
      dispatch(
        setFetchOptionReceivable({
          sortby: column.sortField,
          sortdir: direction,
        }),
      )
    } else {
      dispatch(
        setFetchOption({
          sortby: column.sortField,
          sortdir: direction,
        }),
      )
    }
  }

  const columns = [
    {
      name: <span>Tanggal</span>,
      minWidth: '150px',
      sortField: 'createdAt',
      sortable: true,
      selector: (row) => formatDatePMB(row?.createdAt) || '-',
      cell: (row) => <div>{formatDatePMB(row?.createdAt) || '-'}</div>,
      isFreeze: true,
      freezePosition: 'left',
    },
    {
      name: <span>Nomor Invoice</span>,
      minWidth: '150px',
      selector: (row) => row?.invoiceNumber || '-',
      cell: (row) => <div>{row?.invoiceNumber || '-'}</div>,
      isFreeze: true,
      freezePosition: 'left',
    },
    {
      name: <span>Invoice Sebelumnya</span>,
      minWidth: '150px',
      selector: (row) => row?.prevInvoiceNumbers || '-',
      cell: (row) => <div>{row?.prevInvoiceNumbers || '-'}</div>,
      omit: !dataReceivable,
    },
    {
      name: <span>Nama</span>,
      minWidth: '300px',
      selector: (row) =>
        row?.payerName || row?.buyerName || row?.name || row?.sellerName || '-',
      cell: (row) => {
        const picName = !row?.userId || !row?.payerUserId || !row?.escrowpaymentId
          ? dataReceivable
            ? row?.payerName || row?.buyerName
            : row?.name || row?.sellerName
          : dataReceivable
            ? row?.buyerName || row?.payerName
            : row?.sellerName || row?.name

        const displayName = picName || '-'

        const partnershipName = dataReceivable
          ? row?.buyerPartnershipName
          : row?.sellerPartnershipName

        const avatarSrc = dataReceivable
          ? row?.buyerAvatar || row?.payerAvatar || row?.buyerPartnershipLogo
          : row?.sellerAvatar || row?.payeeAvatar || row?.sellerPartnershipLogo

        const avatarSeed = dataReceivable
          ? row?.payerUserId || row?.buyerUserId
          : row?.userId || row?.sellerUserId

        return (
          <div className="d-flex align-items-start gap-2 py-2">
            <ProfilePic
              imgSrc={avatarSrc}
              altText={displayName}
              name={displayName}
              avatarSeed={avatarSeed}
              width={28}
              height={28}
            />

            <div
              className="d-flex flex-column"
              style={{
                minWidth: 0,
                lineHeight: '1.3',
              }}
            >
              <span
                className="fw-medium"
                style={{
                  wordBreak: 'break-word',
                }}
              >
                {displayName}
              </span>

              {partnershipName && (
                <div
                  className="d-flex flex-column"
                  style={{ marginTop: '2px' }}
                >
                  <span
                    className="text-primary fw-semibold"
                    style={{
                      fontSize: '0.8rem',
                      wordBreak: 'break-word',
                    }}
                  >
                    {partnershipName}
                  </span>
                </div>
              )}
            </div>
          </div>
        )
      },
    },
    {
      name: <span>Total</span>,
      minWidth: '150px',
      sortField: 'amount',
      sortable: true,
      right: true,
      selector: (row) => row?.amount ?? 0,
      cell: (row) => (
        <div className="text-end">
          Rp
          {intl.formatNumber(row?.amount ?? 0, {
            useGrouping: 'always',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
        </div>
      ),
    },
    {
      name: <span>{dataReceivable ? 'Diterima' : 'Dibayar'}</span>,
      minWidth: '150px',
      right: true,
      selector: (row) => row?.amountPaid ?? 0,
      cell: (row) => (
        <div className="text-end">
          Rp
          {intl.formatNumber(row?.amountPaid ?? 0, {
            useGrouping: 'always',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
        </div>
      ),
    },
    {
      name: <span>Sisa</span>,
      minWidth: '150px',
      sortField: 'amountRemaining',
      sortable: true,
      right: true,
      selector: (row) => row?.amountRemaining ?? 0,
      cell: (row) => {
        return (
          <div className="text-end">
            Rp
            {intl.formatNumber(row?.amountRemaining, {
              useGrouping: 'always',
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
          </div>
        )
      },
    },
    ...(type === "company"
      ? [
        {
          name: <span>Project</span>,
          minWidth: "150px",
          selector: (row) => row?.projectLabel || "-",
          cell: (row) => <div>{row?.projectLabel || "-"}</div>,
        },
      ]
      : []),
    {
      name: <span>Kategori</span>,
      minWidth: '150px',
      selector: (row) => row?.categoryName,
      cell: (row) => <span>{row?.categoryName}</span>
    },
    {
      name: <span>Tipe</span>,
      center: true,
      minWidth: '150px',
      selector: (row) =>
        !row?.userId ||
          !row?.payerUserId ||
          (!row?.escrowpaymentId && !row?.prevInvoiceNumbers)
          ? 'Catat Manual'
          : 'Transaksi',
      cell: (row) =>
        !row?.userId ||
          !row?.payerUserId ||
          (!row?.escrowpaymentId && !row?.prevInvoiceNumbers) ? (
          <div className="badge rounded-pill px-2 bg-warning-50 text-warning-700">
            Catat Manual
          </div>
        ) : (
          <div className="badge rounded-pill px-2 bg-success-50 text-success">
            Transaksi
          </div>
        ),
    },
    {
      name: <span>Status</span>,
      center: true,
      minWidth: '150px',
      sortField: 'status',
      sortable: true,
      selector: (row) => getStatus(row),
      cell: (row) => {
        const status = row?.status?.toLowerCase()
        let className = 'badge rounded-pill px-2'

        if (status === 'paid') {
          className += ' bg-success-50 text-success'
        } else if (status === 'open') {
          className += ' bg-warning-50 text-warning-700'
        } else {
          className += ' bg-primary-50 text-primary'
        }

        return (
          <div style={{ minWidth: 80, textAlign: 'center' }}>
            <div className={className}>{row?.status}</div>
          </div>
        )
      },
    },
    {
      name: <span></span>,
      minWidth: '60px',
      right: true,
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-end">
          {(hasCompanyAbilityREAD || hasPersonalAbilityREAD) && <LihatDetail
            onClick={() => {
              dataReceivable
                ? navigate(`${URL_DETAIL_PIUTANG}?id=${row?.id}`)
                : navigate(`${URL_DETAIL_UTANG}?id=${row?.id}`)
              setSelectedRow(row)
            }}
            id={row?.id}
            data-testid={`${f}-row-detail-${row.id}`}
          />}
        </div>
      ),
      isFreeze: true,
      freezePosition: 'right',
    },
  ]

  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows)
  }

  const clearSelectedRows = () => {
    setSelectedRows([])
    setToggleClearRows((v) => !v)
  }

  const handleBulkPay = () => {
    dispatch(
      dataReceivable ? toggleModalAdjustReceivable() : toggleModalAdjust(),
    )
  }

  const handleBulkAdjust = () => {
    dispatch(
      dataReceivable ? toggleModalAdjustReceivable() : toggleModalAdjust(),
    )
  }

  const handleResetFilter = () => {
    setSearchInput('')
    if (dataReceivable) {
      dispatch(
        setFetchOptionReceivable({
          status: undefined,
          payment: undefined,
          projectId: undefined,
          from: undefined,
          to: undefined,
          counterparty: undefined,
        }),
      )
    }
    dispatch(
      setFetchOption({
        status: undefined,
        payment: undefined,
        projectId: undefined,
        from: undefined,
        to: undefined,
        counterparty: undefined,
      }),
    )

    setSelectedContact(null)
  }

  const handleMergeSubmit = async () => {
    try {
      const body = {
        invoiceNumber: mergeInvoiceNum,
        arrPayableIds: selectedRows.map((r) => r.id),
        notes: mergeNotes,
        projectId: mergeProject?.value || mergeProject?.id || null,
      }
      await mergeReceiveable(body).unwrap()
      setIsOpenMergeModal(false)
      clearSelectedRows()
      setMergeInvoiceNum('')
      setMergeNotes('')
      setMergeProject(null)
      refetch()
      enqueueSnackbar('Berhasil menggabungkan piutang', { variant: 'success' })
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message || error?.message || 'Gagal menggabungkan piutang',
        { variant: 'error' },
      )
    }
  }

  const isManualSelected = useMemo(() => {
    if (!selectedRows || selectedRows.length === 0) return false
    return !selectedRows[0]?.escrowpaymentId
  }, [selectedRows])

  const hasMixedUsers = useMemo(() => {
    if (!selectedRows || selectedRows.length < 2) return false
    const firstPayer = selectedRows[0]?.payerUserId
    return !selectedRows.every((r) => r.payerUserId === firstPayer)
  }, [selectedRows])

  const isMergedSelected = useMemo(() => {
    if (!selectedRows || selectedRows.length === 0) return false
    return selectedRows.some((r) => r.prevInvoiceNumbers)
  }, [selectedRows])

  const selectableRowDisabled = (row) => {
    if (!selectedRows || selectedRows.length === 0) return false    // Only restriction: do not mix Escrow (Transaksi) and Non-Escrow (Manual) for bulk Adjust/Pay
    const selectedIsEscrow = selectedRows[0]?.escrowpaymentId ? true : false
    const currentIsEscrow = row?.escrowpaymentId ? true : false

    return selectedIsEscrow !== currentIsEscrow
  }

  useEffect(() => {
    if (type === 'personal') {
      dispatch(
        getUsersFilterArapPersonal({
          type: dataReceivable ? 'receivable' : 'payable',
          size: 100,
          page: 0,
        }),
      )
    } else {
      dispatch(
        getUsersFilterArap({
          type: dataReceivable ? 'receivable' : 'payable',
          size: 100,
          page: 0,
        }),
      )
    }
  }, [])

  const renderMobileCard = (row, index, { isSelected, isDisabled, onSelect } = {}) => {
    return (
      <div
        key={row.id || index}
        className="border p-3 shadow-sm mt-2 mb-3 bg-white"
        style={{ borderRadius: '12px', opacity: isDisabled ? 0.6 : 1 }}
        data-testid={`${f}-table-row-${row.id}`}
      >
        {/* Header: Checkbox + Name + Badges */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center gap-2" style={{ maxWidth: '60%' }}>
            {onSelect && (
              <input
                type="checkbox"
                className="form-check-input m-0"
                style={{ cursor: 'pointer', width: '20px', height: '20px', flexShrink: 0 }}
                checked={isSelected}
                disabled={isDisabled}
                onChange={onSelect}
              />
            )}
            {(() => {
              const picName = !row?.userId || !row?.payerUserId || !row?.escrowpaymentId
                ? dataReceivable
                  ? row?.payerName || row?.buyerName
                  : row?.name || row?.sellerName
                : dataReceivable
                  ? row?.buyerName || row?.payerName
                  : row?.sellerName || row?.name

              const displayName = picName || '-'
              const partnershipName = dataReceivable
                ? row?.buyerPartnershipName
                : row?.sellerPartnershipName
              const avatarSrc = dataReceivable
                ? row?.buyerAvatar || row?.payerAvatar || row?.buyerPartnershipLogo
                : row?.sellerAvatar || row?.payeeAvatar || row?.sellerPartnershipLogo
              const avatarSeed = dataReceivable
                ? row?.payerUserId || row?.buyerUserId
                : row?.userId || row?.sellerUserId

              return (
                <div className="d-flex align-items-center gap-2 text-truncate">
                  <ProfilePic
                    imgSrc={avatarSrc}
                    altText={displayName}
                    name={displayName}
                    avatarSeed={avatarSeed}
                    width={28}
                    height={28}
                  />
                  <div className="d-flex flex-column text-truncate" style={{ lineHeight: '1.3' }}>
                    <div className="fw-bold text-dark fs-6 text-truncate">
                      {displayName}
                    </div>
                    {partnershipName && (
                      <div
                        className="text-primary fw-semibold text-truncate"
                        style={{ fontSize: '0.8rem', marginTop: '2px' }}
                      >
                        {partnershipName}
                      </div>
                    )}
                  </div>
                </div>
              )
            })()}
          </div>
          <div className="d-flex align-items-center gap-1 flex-wrap justify-content-end">
            {(() => {
              const status = row?.status?.toLowerCase()
              let className = 'badge rounded-pill px-2'
              if (status === 'paid') className += ' bg-success-50 text-success'
              else if (status === 'open') className += ' bg-warning-50 text-warning-700'
              else className += ' bg-primary-50 text-primary'
              return <div className={className} style={{ fontSize: '10px' }}>{row?.status}</div>
            })()}

            {(!row?.userId || !row?.payerUserId || (!row?.escrowpaymentId && !row?.prevInvoiceNumbers)) ? (
              <div className="badge rounded-pill px-2 bg-warning-50 text-warning-700" style={{ fontSize: '10px' }}>Catat Manual</div>
            ) : (
              <div className="badge rounded-pill px-2 bg-success-50 text-success" style={{ fontSize: '10px' }}>Transaksi</div>
            )}
          </div>
        </div>

        {/* Subtitle: Date & Invoice */}
        <div className="d-flex justify-content-between mb-3 pb-3 border-bottom">
          <div className="text-muted" style={{ fontSize: '13px' }}>
            {formatDatePMB(row?.createdAt) || '-'}
          </div>
          <div className="text-muted" style={{ fontSize: '13px' }}>
            INV: {row?.invoiceNumber || '-'}
          </div>
        </div>

        {/* Amounts */}
        <div className="d-flex justify-content-between mb-2">
          <div className="text-muted" style={{ fontSize: '13px' }}>Total</div>
          <div className="fw-medium text-dark" style={{ fontSize: '14px' }}>
            Rp{intl.formatNumber(row?.amount ?? 0, { useGrouping: 'always' })}
          </div>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div className="text-muted" style={{ fontSize: '13px' }}>{dataReceivable ? 'Diterima' : 'Dibayar'}</div>
          <div className="fw-medium text-dark" style={{ fontSize: '14px' }}>
            Rp{intl.formatNumber(row?.amountPaid ?? 0, { useGrouping: 'always' })}
          </div>
        </div>

        {/* Highlight Sisa */}
        <div className="d-flex justify-content-between align-items-center mb-3 pt-2">
          <span className="fw-semibold text-dark" style={{ fontSize: '14px' }}>Sisa {dataReceivable ? 'Piutang' : 'Utang'}</span>
          <span className="fw-bold text-primary" style={{ fontSize: '16px' }}>Rp{intl.formatNumber(row?.amountRemaining ?? 0, { useGrouping: 'always' })}</span>
        </div>

        {/* Footer */}
        <div className="w-100">
          {(hasCompanyAbilityREAD || hasPersonalAbilityREAD) && <div
            className="text-primary text-center fw-medium py-2"
            style={{ cursor: 'pointer', fontSize: '14px', backgroundColor: '#F8FAFC', borderRadius: '8px' }}
            onClick={() => {
              dataReceivable
                ? navigate(`${URL_DETAIL_PIUTANG}?id=${row?.id}`)
                : navigate(`${URL_DETAIL_UTANG}?id=${row?.id}`)
              setSelectedRow(row)
            }}
            data-testid={`${f}-row-detail-${row.id}`}
          >
            <Eye size={14} className="me-2" /> Lihat Detail
          </div>}

        </div>
      </div>
    )
  }

  return (
    <div>
      {/* <SidebarPayableNotes
        row={selectedRow}
        isReceivable={dataReceivable ? true : false}
        isOpen={dataReceivable ? isOpenSidebarReceivable : isOpenSidebar}
        toggle={() =>
          dispatch(dataReceivable ? toggleSidebarReceivable() : toggleSidebar())
        }
      /> */}

      <ModalAdjustPayable
        row={selectedRows}
        isReceivable={dataReceivable ? true : false}
        isOpen={
          dataReceivable ? isOpenModalAdjustReceivable : isOpenModalAdjust
        }
        toggle={() =>
          dispatch(
            dataReceivable
              ? toggleModalAdjustReceivable()
              : toggleModalAdjust(),
          )
        }
        refetch={refetch}
        clearSelectedRows={clearSelectedRows}
      />
      <Modal
        isOpen={isOpenMergeModal}
        toggle={() => setIsOpenMergeModal(false)}
        centered
        data-testid={`${f}-modal-merge`}
      >
        <div className="modal-header border-bottom-0 pb-0">
          <h5 className="modal-title fw-bold">Gabungkan Piutang</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setIsOpenMergeModal(false)}
          ></button>
        </div>
        <ModalBody className="pt-2 pb-4">
          <div className="mb-3">
            <Label className="fw-semibold">Nomor Invoice Baru</Label>
            <Input
              type="text"
              placeholder="Cth: INV/001"
              value={mergeInvoiceNum}
              onChange={(e) => setMergeInvoiceNum(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <Label className="fw-semibold">Catatan</Label>
            <Input
              type="textarea"
              placeholder="Tambahkan catatan"
              value={mergeNotes}
              onChange={(e) => setMergeNotes(e.target.value)}
              rows="3"
            />
          </div>
          <div className="mb-4">
            <Label className="fw-semibold">Project (Opsional)</Label>
            <PMBProjectSelections
              style={{
                borderColor: 'white',
                caretColor: 'transparent',
              }}
              className="border-input button w-100"
              placeholder="Pilih project"
              value={mergeProject}
              onChange={(project) => setMergeProject(project)}
            />
            <div className="mt-2 small text-muted">
              (ID Payables: {selectedRows.map((r) => r.id).join(', ')})
              <br />
              (Invoice Sebelumnya:{' '}
              {selectedRows.map((r) => r.invoiceNumber || '-').join(', ')})
            </div>
          </div>

          {hasMixedUsers && (
            <Alert
              color="danger"
              className="py-2 text-sm d-flex align-items-center mb-3"
            >
              Piutang yang digabungkan harus berasal dari pembeli/nama yang
              sama.
            </Alert>
          )}

          <p className="mb-0 text-muted">
            Apakah Anda yakin ingin menggabungkan {selectedRows?.length} data
            piutang ini? Tindakan ini tidak dapat dibatalkan.
          </p>
          <div className="d-flex gap-2 justify-content-end mt-4">
            <CustomButton
              outline
              color="secondary"
              className="btn-cancel"
              disabled={isMerging}
              onClick={() => setIsOpenMergeModal(false)}
              testId={`${f}-modal-merge-cancel`}
            >
              Batal
            </CustomButton>
            <CustomButton
              color="primary"
              disabled={isMerging || hasMixedUsers}
              onClick={handleMergeSubmit}
              testId={`${f}-modal-merge-submit`}
            >
              {isMerging ? <Spinner size="sm" /> : 'Ya, Gabungkan'}
            </CustomButton>
          </div>
        </ModalBody>
      </Modal>
      <>
        {!dataReceivable && pendingPayable?.totalCount > 0 ? (
          <div
            onClick={() => navigate(URL_UTANG_APPROVAL)}
            className="d-flex align-items-center justify-content-between p-3 rounded mb-4 border pointer position-relative"
            style={{
              background: 'linear-gradient(135deg, #f0f7ff 0%, #e0effe 100%)',
              borderColor: '#b3d8ff',
              transition: 'all 0.2s ease-in-out',
              boxShadow: '0 2px 8px rgba(0, 82, 204, 0.04)',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 82, 204, 0.08)'
              e.currentTarget.style.borderColor = '#80bfff'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 82, 204, 0.04)'
              e.currentTarget.style.borderColor = '#b3d8ff'
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <div
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: '#ffffff',
                  color: '#0052cc',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                }}
              >
                <AlertCircle size={20} />
              </div>
              <div className="d-flex flex-column">
                <span className="fw-bold text-dark mb-0" style={{ fontSize: '0.95rem' }}>
                  Konfirmasi Catatan
                </span>
                <span className="text-secondary" style={{ fontSize: '0.85rem' }}>
                  Ada <strong>{pendingPayable?.totalCount}</strong> catatan yang membutuhkan persetujuan Anda.
                </span>
              </div>
            </div>
            <div
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: '32px',
                height: '32px',
                backgroundColor: 'rgba(0, 82, 204, 0.05)',
                color: '#0052cc',
              }}
            >
              <ArrowRight size={18} />
            </div>
          </div>
        ) : null}
        <div className="pb-5">
          <>
            <TableComponent
              renderMobileCard={renderMobileCard}
              sortServer
              defaultSortFieldId={1}
              onSort={handleSort}
              selectableRows
              selectableRowDisabled={selectableRowDisabled}
              onSelectedRowsChange={handleSelectedRowsChange}
              clearSelectedRows={toggledClearRows}
              columns={columns}
              data={data?.items || []}
              progressPending={loading || isLoading || status === 'pending'}
              pagination={true}
              paginationServer={true}
              paginationComponent={() => (
                <PMBPagination
                  rowCount={data?.totalItems || 0}
                  currentPage={
                    dataReceivable ? tagReceiveable?.page : tag?.page || 0
                  }
                  rowsPerPage={
                    dataReceivable ? tagReceiveable?.size : tag?.size || 10
                  }
                  setCurrentPage={(page) => {
                    if (dataReceivable) {
                      dispatch(
                        setFetchOptionReceivable({
                          page: page,
                        }),
                      )
                    } else {
                      dispatch(
                        setFetchOption({
                          page: page,
                        }),
                      )
                    }
                  }}
                  setRowsPerPage={(size) => {
                    if (dataReceivable) {
                      dispatch(
                        setFetchOptionReceivable({
                          size: size,
                        }),
                      )
                    } else {
                      dispatch(
                        setFetchOption({
                          size: size,
                        }),
                      )
                    }
                  }}
                />
              )}
              subHeader
              subHeaderComponent={
                <div className="w-100 mb-3">
                  {/* ROW 1 */}
                  <div
                    className="d-flex justify-content-between align-items-center flex-wrap"
                    style={{ gap: '16px' }}
                  >
                    <div className="d-flex gap-3 mb-2 flex-wrap flex-sm-nowrap w-100">
                      {/* Total Outstanding */}
                      <div
                        className="p-3 rounded bg-white d-flex align-items-center justify-content-between shadow-sm border flex-grow-1 flex-sm-grow-0"
                        style={{
                          minWidth: '180px',
                          borderColor: '#e2e8f0',
                          borderLeft: '4px solid #3b82f6',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)'
                          e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)'
                          e.currentTarget.style.boxShadow = 'none'
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="text-muted small fw-semibold mb-1">
                            {dataReceivable ? 'Sisa Piutang' : 'Sisa Utang'}
                          </span>
                          <span className="fw-bold text-dark h5 mb-0">
                            Rp
                            {intl.formatNumber(summary.totalOutstanding ?? 0, {
                              useGrouping: 'always',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                        {/* <div
                          className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(59, 130, 246, 0.1)',
                            color: '#3b82f6',
                          }}
                        >
                          <DollarSign size={20} />
                        </div> */}
                      </div>

                      {/* Total Items */}
                      <div
                        className="p-3 rounded bg-white d-flex align-items-center justify-content-between shadow-sm border flex-grow-1 flex-sm-grow-0"
                        style={{
                          minWidth: '150px',
                          borderColor: '#e2e8f0',
                          borderLeft: '4px solid #10b981',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)'
                          e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)'
                          e.currentTarget.style.boxShadow = 'none'
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="text-muted small fw-semibold mb-1">Total</span>
                          <span className="fw-bold text-dark h5 mb-0">{data?.totalItems || 0}</span>
                        </div>
                        {/* <div
                          className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(16, 185, 129, 0.1)',
                            color: '#10b981',
                          }}
                        >
                          <FileText size={20} />
                        </div> */}
                      </div>
                    </div>

                    {/* RIGHT SIDE: Buttons */}
                    <div
                      className="d-flex align-items-center flex-wrap mt-2 mt-md-0"
                      style={{ gap: '12px' }}
                    >
                      <div className="d-flex gap-2">
                        {(dataReceivable
                          ? activeFilterCountReceivable
                          : activeFilterCount) > 0 && (
                            <CustomButton
                              onClick={handleResetFilter}
                              color="danger"
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: '40px',
                                height: '40px',
                                padding: 0,
                                minWidth: '40px',
                              }}
                            >
                              <SvgIcon name="x" size={16} color="white" />
                            </CustomButton>
                          )}
                        <CustomButton
                          onClick={() =>
                            setIsShowFilter((prevState) => !prevState)
                          }
                          color="primary"
                          className="position-relative text-nowrap"
                          outline
                        >
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            <Filter size={15} />
                            <P>Filter</P>
                            {(dataReceivable
                              ? activeFilterCountReceivable
                              : activeFilterCount) > 0 && (
                                <Badge
                                  color="danger"
                                  pill
                                  style={{
                                    position: 'absolute',
                                    top: '-5px',
                                    right: '-5px',
                                    fontSize: '10px',
                                  }}
                                >
                                  {dataReceivable
                                    ? activeFilterCountReceivable
                                    : activeFilterCount}
                                </Badge>
                              )}
                            {isShowFilter ? (
                              <ChevronUp size={16} className="ml-2" />
                            ) : (
                              <ChevronDown size={16} className="ml-2" />
                            )}
                          </div>
                        </CustomButton>
                      </div>
                      {/* CATAT */}

                      {(hasPersonalAbilityMANAGE || hasCompanyAbilityMANAGE) && <CustomButton
                        onClick={() =>
                          navigate(URL_FORM_UTANG_PIUTANG, {
                            state: { isReceivable: dataReceivable },
                          })
                        }
                        disabled={isLoading || loading}
                        color="primary"
                        className="text-nowrap"
                      >
                        + Catat {dataReceivable ? 'Piutang' : 'Utang'}
                      </CustomButton>}

                      {/* ADJUST / PAY */}
                      {selectedRows?.length > 0 && (
                        <>
                          {dataReceivable ? (
                            (hasPersonalAbilityMANAGE || hasCompanyAbilityMANAGE) &&
                            <>
                              <CustomButton
                                color="primary"
                                className="text-nowrap"
                                disabled={
                                  selectedRows?.length < 2 || isManualSelected || isMergedSelected
                                }
                                onClick={() => setIsOpenMergeModal(true)}
                              >
                                Gabungkan ({selectedRows?.length ?? 0})
                              </CustomButton>
                              <CustomButton
                                color="primary"
                                className="text-nowrap"
                                disabled={selectedRows?.length < 1}
                                onClick={handleBulkAdjust}
                              >
                                Sesuaikan ({selectedRows?.length ?? 0})
                              </CustomButton>
                            </>
                          ) : (
                            (hasPersonalAbilityMANAGE || hasCompanyAbilityMANAGE) &&
                            <CustomButton
                              color="primary"
                              className="text-nowrap"
                              disabled={selectedRows?.length < 1}
                              onClick={handleBulkPay}
                            >
                              Bayar ({selectedRows?.length ?? 0})
                            </CustomButton>

                          )}
                        </>
                      )}
                    </div>
                  </div>

                  {/* LEFT SIDE: Search */}

                  <Collapse isOpen={isShowFilter} className="mt-3">
                    <div
                      className="border rounded p-3 bg-light mb-3 filter-collapse"
                      style={{
                        width: '100%',
                        transition: 'all 0.3s ease-in-out',
                        opacity: isShowFilter ? 1 : 0,
                        // transform: isShowFilter ? 'translateY(0)' : 'translateY(-10px)',
                      }}
                    >
                      <Row className="mt-3">
                        <Col xs={12} md={3} lg={3} className="mb-3">
                          <PMBSearchInputGroup
                            label="Cari"
                            value={searchInput}
                            placeholder="Cari..."
                            onChange={(e) =>
                              onHandleSearchChange(e.target.value)
                            }
                            maxWidth="100%"
                            onKeyDown={handleKeyDown}
                            testId={`${f}-search-input`}
                          />
                        </Col>

                        <Col xs={12} md={3} lg={3} className="mb-3">
                          <p
                            className="mb-2"
                            style={{
                              display: 'inline-block',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            Tanggal
                          </p>
                          <PMBDateRangePicker
                            style={{ width: '100%', maxWidth: '100%' }}
                            data-testid={`${f}-date-filter`}
                            value={
                              dataReceivable
                                ? [
                                  tagReceiveable?.from
                                    ? moment(tagReceiveable.from).format(
                                      'YYYY-MM-DD',
                                    )
                                    : null,
                                  tagReceiveable?.to
                                    ? moment(tagReceiveable.to).format(
                                      'YYYY-MM-DD',
                                    )
                                    : null,
                                ]
                                : [
                                  tag?.from
                                    ? moment(tag.from).format('YYYY-MM-DD')
                                    : null,
                                  tag?.to
                                    ? moment(tag.to).format('YYYY-MM-DD')
                                    : null,
                                ]
                            }
                            onChange={(dates) => {
                              if (dates && dates.length === 2) {
                                const [startStr, endStr] = dates
                                if (dataReceivable) {
                                  dispatch(
                                    setFetchOptionReceivable({
                                      from: moment(startStr)
                                        .startOf('day')
                                        .toISOString(),
                                      to: moment(endStr)
                                        .endOf('day')
                                        .toISOString(),
                                    }),
                                  )
                                } else {
                                  dispatch(
                                    setFetchOption({
                                      from: moment(startStr)
                                        .startOf('day')
                                        .toISOString(),
                                      to: moment(endStr)
                                        .endOf('day')
                                        .toISOString(),
                                    }),
                                  )
                                }
                              } else if (dates === null) {
                                // Handle clear
                                if (dataReceivable) {
                                  dispatch(
                                    setFetchOptionReceivable({
                                      from: undefined,
                                      to: undefined,
                                    }),
                                  )
                                } else {
                                  dispatch(
                                    setFetchOption({
                                      from: undefined,
                                      to: undefined,
                                    }),
                                  )
                                }
                              }
                            }}
                            format="yyyy-mm-dd"
                            label=""
                          />
                        </Col>

                        <Col xs={12} md={3} lg={3} className="mb-3">
                          <p className="mb-2">Status</p>
                          <PMBSelect
                            isClearable={
                              (dataReceivable
                                ? tagReceiveable?.status
                                : tag?.status) === undefined
                                ? false
                                : true
                            }
                            style={{ width: '100%' }}
                            options={statusOptions}
                            testId={`${f}-filter-status-select`}
                            value={
                              statusOptions.find(
                                (option) =>
                                  String(option.value) ===
                                  String(
                                    dataReceivable
                                      ? tagReceiveable?.status
                                      : tag?.status,
                                  ),
                              ) ?? undefined
                            }
                            placeholder="Pilih Status..."
                            onChange={(e) => {
                              // Client-side filtering: notify parent to update pagination tag
                              if (dataReceivable) {
                                dispatch(
                                  setFetchOptionReceivable({
                                    status: e?.value,
                                  }),
                                )
                              } else {
                                dispatch(
                                  setFetchOption({
                                    status: e?.value,
                                  }),
                                )
                              }
                            }}
                          />
                        </Col>

                        <Col xs={12} md={3} lg={3} className="mb-3">
                          <p className="mb-2">Nama</p>
                          <PMBSelect
                            isClearable={true}
                            options={usersFilterArap}
                            style={{ width: '100%' } ?? []}
                            value={
                              usersFilterArap?.find(
                                (option) =>
                                  String(option.value) ===
                                  String(
                                    dataReceivable
                                      ? tagReceiveable?.counterparty
                                      : tag?.counterparty,
                                  ),
                              ) ?? undefined
                            }
                            placeholder="Pilih Nama..."
                            onChange={(e) => {
                              // Client-side filtering: notify parent to update pagination tag
                              if (dataReceivable) {
                                dispatch(
                                  setFetchOptionReceivable({
                                    counterparty: e?.value,
                                  }),
                                )
                              } else {
                                dispatch(
                                  setFetchOption({
                                    counterparty: e?.value,
                                  }),
                                )
                              }
                            }}
                          />
                        </Col>

                        <Col xs={12} md={3} lg={3} className="mb-3">
                          <p className="mb-2">Kategori</p>
                          <PMBSelect
                            isClearable={true}
                            options={categoryOptions}
                            style={{ width: '100%' }}
                            testId={`${f}-filter-category-select`}
                            value={
                              categoryOptions?.find(
                                (option) =>
                                  String(option.value) ===
                                  String(
                                    dataReceivable
                                      ? tagReceiveable?.categoryId
                                      : tag?.categoryId,
                                  ),
                              ) ?? undefined
                            }
                            placeholder="Pilih Kategori..."
                            onChange={(e) => {
                              if (dataReceivable) {
                                dispatch(
                                  setFetchOptionReceivable({
                                    categoryId: e?.value,
                                  }),
                                )
                              } else {
                                dispatch(
                                  setFetchOption({
                                    categoryId: e?.value,
                                  }),
                                )
                              }
                            }}
                          />
                        </Col>
                        {
                          type === 'company' &&
                          <Col xs={12} md={3} lg={3} className="mb-3">
                            <p className="mb-2">Project</p>
                            <PMBProjectSelections
                              value={
                                dataReceivable
                                  ? tagReceiveable?.projectId
                                  : tag?.projectId
                              }
                              onChange={(e) => {
                                if (dataReceivable) {
                                  dispatch(
                                    setFetchOptionReceivable({
                                      projectId: e?.value,
                                    }),
                                  )
                                } else {
                                  dispatch(
                                    setFetchOption({
                                      projectId: e?.value,
                                    }),
                                  )
                                }
                              }}
                              placeholder="Pilih project"
                            />
                          </Col>
                        }

                        {/* <Col xs={12} md={3} lg={3}>
                          <DropdownAddressBook
                            title={'Nama'}
                            onSelectContact={(e) => {
                              setSelectedContact(e)
                              if (dataReceivable) {
                                dispatch(
                                  setFetchOptionReceivable({
                                    counterparty:
                                      e?.relationUserId ?? e?.relationName,
                                  }),
                                )
                              } else {
                                dispatch(
                                  setFetchOption({
                                    counterparty:
                                      e?.relationUserId ?? e?.relationName,
                                  }),
                                )
                              }
                            }}
                            fieldName="relationName"
                            onClickAdd={(localSearch) =>
                              dispatch(setSearchAddressBook(localSearch))
                            }
                            innerRef={addressBookRef}
                            isCloseSelection={selectedContact?.relationName}
                            valueName={
                              selectedContact
                                ? {
                                    label:
                                      selectedContact?.partnership?.name ??
                                      selectedContact?.fullName ??
                                      selectedContact?.relationName,
                                    value: selectedContact?.userId,
                                  }
                                : ''
                            }
                            isCanClose
                            noAdd
                            placeholderDesc={'Pilih Nama...'}
                          />
                        </Col> */}
                      </Row>
                    </div>
                  </Collapse>
                </div>
              }
            />
          </>
        </div>
      </>
    </div>
  )
}

export default PayableNotes

// data?.length > 0 ? (
//   data?.map((e, i) => {
//     return (
//       <div key={i}>
//         <Card
//           style={{ cursor: 'pointer' }}
//           className="mt-4"
//           onClick={() => {
//             dataReceivable
//               ? navigate(`${URL_DETAIL_PIUTANG}?id=${e?.id}`)
//               : navigate(`${URL_DETAIL_UTANG}?id=${e?.id}`)
//             setSelectedRow(e)
//           }}
//         >
//           <CardBody>
//             <div className="d-flex justify-content-between">
//               {!e?.userId ||
//               !e?.payerUserId ||
//               !e?.escrowpaymentId ? (
//                 <Badge className="badge-warning">
//                   Catat Manual
//                 </Badge>
//               ) : (
//                 <Badge className="badge-verify">Transaksi</Badge>
//               )}
//               {e?.amount === e?.amountPaid && (
//                 <div
//                   style={{
//                     backgroundColor: '#ECFDF3',
//                     color: '#027A48',
//                   }}
//                   className="badge rounded-pill flex-centered"
//                 >
//                   Lunas
//                 </div>
//               )}
//             </div>
//             <div className="d-flex justify-content-between align-items-center mt-3">
//               <span
//                 className="fw-600 text-truncate me-2"
//                 style={{ maxWidth: '60%' }}
//               >
//                 {!e?.userId ||
//                 !e?.payerUserId ||
//                 !e?.escrowpaymentId
//                   ? dataReceivable
//                     ? e?.payerName
//                     : e?.name
//                   : dataReceivable
//                     ? e?.buyerName
//                     : e?.sellerName}
//               </span>
//               <span className="text-primary fw-700 text-nowrap">
//                 Rp
//                 {intl.formatNumber(e?.amount ?? 0, {
//                   useGrouping: 'always',
//                   minimumFractionDigits: 0,
//                   maximumFractionDigits: 0,
//                 })}
//               </span>
//             </div>
//             <div className="d-flex gap-2">
//               <div className="text-gray-500">
//                 {formatDatePMBV2(e?.createdAt)}
//               </div>
//               <div className="text-gray-500">•</div>
//               <div className="text-primary-600 fw-500">
//                 Kategori: {e?.categoryName || '-'}
//               </div>
//             </div>
//             <div className="mt-3">
//               <span className="fw-500">
//                 {dataReceivable
//                   ? 'Sudah terima pembayaran'
//                   : 'Sudah Bayar'}
//               </span>
//               <Progress
//                 color="success"
//                 style={{ height: '8px' }}
//                 className="my-1"
//                 value={
//                   ((e?.amountPaid ?? 0) * 100) / (e?.amount ?? 0)
//                 }
//               />
//               <span>
//                 <span className="fw-600 text-gray-500">
//                   Rp
//                   {intl.formatNumber(e?.amountPaid ?? 0, {
//                     useGrouping: 'always',
//                     minimumFractionDigits: 0,
//                     maximumFractionDigits: 0,
//                   })}{' '}
//                 </span>
//                 <span className="fw-400 text-gray-500">
//                   dari Rp
//                   {intl.formatNumber(e?.amount ?? 0, {
//                     useGrouping: 'always',
//                     minimumFractionDigits: 0,
//                     maximumFractionDigits: 0,
//                   })}
//                 </span>
//               </span>
//             </div>
//           </CardBody>
//         </Card>
//       </div>
//     )
//   })

// )
